import { motion } from "framer-motion";

const TIMELINE = [
  {
    year: "2011",
    title: "Founded in Pune",
    body: "Established in Pune as a strategic advisory committed to nation-building outcomes — not deck-making.",
  },
  {
    year: "2014",
    title: "Expansion across Bharat",
    body: "Scaled beyond Maharashtra with engagements across western, northern and southern India — designing governance modernization frameworks adopted by multiple state administrations.",
  },
  {
    year: "2017",
    title: "Healthcare practice launched",
    body: "Architected diagnostics ecosystems and PPP frameworks for tier-2 districts.",
  },
  {
    year: "2020",
    title: "Digital Bharat practice",
    body: "Built citizen-platform blueprints for Digital Public Infrastructure programs.",
  },
  {
    year: "2023",
    title: "Workforce & Skilling vertical",
    body: "Operationalized capability stacks across 14 government departments.",
  },
  {
    year: "2026",
    title: "The Bharat Decade",
    body: "Scaling cross-sector advisory engagements aligned with India's $10T economic horizon.",
  },
];

export const Legacy = () => {
  return (
    <section
      id="legacy"
      data-testid="legacy-section"
      className="relative bg-ivory py-28 md:py-40 scroll-mt-nav overflow-hidden"
    >
      <div className="container-bharat">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <p className="overline">Legacy</p>
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-navy mt-6 leading-[1.05] tracking-tight">
              15 Years of Strategic{" "}
              <span className="italic text-gold">Institution Building</span>.
            </h2>
            <p className="mt-8 text-base md:text-lg text-graphite/70 max-w-md leading-relaxed">
              Bharat Axis Advisory has spent a decade and a half advising
              ministries, state administrations and large enterprises on the
              transformations that turn policy into ground impact.
            </p>
            <div className="hairline mt-10 max-w-sm" />
            <div className="mt-10 grid grid-cols-3 gap-6 max-w-md">
              <div>
                <p className="font-serif-display text-3xl text-navy">15+</p>
                <p className="text-xs text-graphite/60 mt-1">
                  Years of Practice
                </p>
              </div>
              <div>
                <p className="font-serif-display text-3xl text-navy">6</p>
                <p className="text-xs text-graphite/60 mt-1">Core Sectors</p>
              </div>
              <div>
                <p className="font-serif-display text-3xl text-navy">3</p>
                <p className="text-xs text-graphite/60 mt-1">Office Cities</p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 relative">
            <div className="absolute left-[10px] top-2 bottom-2 w-px bg-gradient-to-b from-gold/0 via-gold/60 to-gold/0" />
            <ul className="space-y-12">
              {TIMELINE.map((t, i) => (
                <motion.li
                  key={t.year}
                  initial={{ opacity: 0, x: 20, filter: "blur(6px)" }}
                  whileInView={{ opacity: 1, x: 0, filter: "blur(0)" }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.7, delay: i * 0.05 }}
                  className="relative pl-12"
                  data-testid={`timeline-item-${t.year}`}
                >
                  <span className="absolute left-0 top-2 w-5 h-5 rounded-full border border-gold bg-ivory flex items-center justify-center">
                    <span className="w-2 h-2 rounded-full bg-gold" />
                  </span>
                  <div className="flex items-baseline gap-4 mb-2">
                    <span className="font-display text-sm text-gold tracking-[0.3em]">
                      {t.year}
                    </span>
                    <span className="h-px flex-1 bg-graphite/10" />
                  </div>
                  <h3 className="font-serif-display text-2xl md:text-3xl text-navy">
                    {t.title}
                  </h3>
                  <p className="mt-3 text-graphite/70 max-w-xl leading-relaxed">
                    {t.body}
                  </p>
                </motion.li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Legacy;
